'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import { ReactJsonViewProps } from 'react-json-view';

const ReactJson = dynamic(() => import('react-json-view').then((mod) => mod.default), { ssr: false });

function JsonView(props: ReactJsonViewProps): React.JSX.Element {
  return (
    <ReactJson
      theme="monokai"
      style={{ fontSize: '0.75em', overflow: 'scroll', width: '100%' }}
      enableClipboard={(copy) => {
        if (typeof copy.src === 'object' && copy.name !== 'root') {
          void navigator.clipboard.writeText(JSON.stringify(copy.src, null, 2));
        } else if (typeof copy === 'string') {
          void navigator.clipboard.writeText(copy);
        } else {
          void navigator.clipboard.writeText(JSON.stringify(copy, null, 2));
        }
      }}
      {...props}
    />
  );
}

export default JsonView;
